import { Button, Table } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete.component";

function UsersTable({ users, type }) {
  return (
    <div className="mt-5 table-container">
      <Table striped bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Join date</th>
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{item.username}</td>
              <td>{item.email}</td>
              <td>{item.role}</td>
              <td>{item.createdAt?.split("T")[0]}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default UsersTable;
